import axiosInstance from "./axiosInstance";

const fetchData = async ({ method = "GET", url, data, headers = {} }) => {
  try {
    const response = await axiosInstance({
      method,
      url,
      data,
      headers: {
        ...axiosInstance.defaults.headers,
        ...headers, 
      },
    });
    return response.data;
  } catch (error) {
    console.error(`API Error (${method} ${url}):`, error?.response || error?.message);
    throw error.response?.data || { message: "Something went wrong!" };
  }
};


export default fetchData;
